var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimcard2 = function SvgSimcard2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#282D3C",
    strokeWidth: 2,
    d: "M13.858 2H7.1a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.243a3 3 0 0 0-.879-2.121L15.98 2.879A3 3 0 0 0 13.858 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#282D3C",
    d: "M12.411 17.755q-1.026 0-1.773-.405a2.8 2.8 0 0 1-1.142-1.164q-.396-.758-.396-1.802 0-1.014.4-1.773a2.9 2.9 0 0 1 1.13-1.185Q11.359 11 12.347 11q.699 0 1.279.218.58.217 1.001.643.422.426.656 1.053.235.621.235 1.427v.52h-5.69v-1.21h3.75a1.2 1.2 0 0 0-.157-.592 1.07 1.07 0 0 0-.422-.405q-.264-.15-.61-.15-.347 0-.626.158a1.186 1.186 0 0 0-.61 1.023v1.231q.002.402.159.704.158.297.447.464.29.165.69.166.278 0 .503-.076.226-.078.388-.226a.9.9 0 0 0 .243-.367l1.913.056q-.12.643-.524 1.12a2.66 2.66 0 0 1-1.052.738q-.653.26-1.509.26"
  })));
};
export default SvgSimcard2;